export default __webpack_public_path__ + "static/AzoSansBold-c74ada87293dd874c53d103f7f1bbdb3.woff";